
export default {
    loadInitials: () => ({
        pageInfo: {}
    })
}
